import { CommunicationChatDetails, SearchUser } from '~/types';

export const EMPTY_COMMUNICATION_CHAT_DATA: CommunicationChatDetails = {
    id: '',
    machineId: '',
    projectId: '',
    machineIntern: '',
    machineName: '',
    chat: [],
    chatUsers: [],
};

export enum ChatWebSocketActions {
    ADDUSER = 1,
    DELETEUSER = 2,
    REGISTERISSUE = 3,
    REGISTERTRAINING = 4
}

export enum IssueOrServiceType {
    ISSUE = 0,
    SERVICE = 1,
    PROJECT = 4,
    MACHINE = 5,
}

export enum MessageType {
    ISSUE = 0,
    SERVICE = 1,
    RENTALORDER = 2,
    PROJECT = 4,
    MACHINE = 5,
    NOTIFICATION = 100,
    TRAINING = 101,
    TIME_MANAGEMENT = 102,
}


export const CHAT_INBOX_TYPES = {
    issues: [IssueOrServiceType.ISSUE],
    service: [IssueOrServiceType.SERVICE],
    projects: [IssueOrServiceType.PROJECT],
    maskin: [IssueOrServiceType.MACHINE],
} as const;

export const getChatStoreKey = (type: MessageType): 'issue' | 'service' | 'project' | 'communicationChat' => {
    if (type === MessageType.ISSUE) {
        return 'issue';
    }
    if (type === MessageType.SERVICE) {
        return 'service';
    }
    if (type === MessageType.PROJECT) {
        return 'project';
    }
    return 'communicationChat';
};

export const selectChatData = (state: any, type: MessageType): CommunicationChatDetails => {
    const key = getChatStoreKey(type);
    if (key === 'communicationChat') {
        return state.communicationChat?.data ?? EMPTY_COMMUNICATION_CHAT_DATA;
    }
    return state[key].data;
};

export const selectChatUsers = (state: any, type: MessageType): SearchUser[] =>
    selectChatData(state, type).chatUsers ?? [];
